/**
 * Technical Sheet Module Manifest
 *
 * Defines the available configuration parameters for the technicalSheet module.
 * The key 'technicalsheet' matches Module.actionProperties.redirectTo.
 *
 * This file is NOT exported from packages/domain/src/index.ts.
 * It must be imported directly and registered at app bootstrap:
 *
 * @example
 * // apps/console/src/bootstrap.ts
 * import { technicalSheetManifest } from '@syscolect/domain/src/manifests/technicalSheet.manifest.js';
 * moduleManifestRegistry.register(technicalSheetManifest);
 */
export const technicalSheetManifest = {
    key: 'technicalsheet',
    version: 1,
    name: 'Ficha Tecnica',
    parameters: [
        {
            key: 'type',
            label: 'Tipo de Ficha',
            type: 'enum',
            scope: 'module',
            options: ['chemical', 'metalurgical'],
            default: 'chemical',
        },
        {
            key: 'useDimensions',
            label: 'Utilizar Dimensoes',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
    ],
};
//# sourceMappingURL=technicalSheet.manifest.js.map